import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { LeadForm, LeadFormValues } from "./LeadForm";
import { useCreateLead } from "@/hooks/leads/useLeads";
import { persistLeadPhones } from "@/hooks/leads/useLeadPhones";
import { needsPhonesRoundTrip } from "@/lib/leads/leadPhones";
import { useToast } from "@/hooks/use-toast";

interface LeadCreateModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const LeadCreateModal = ({ open, onOpenChange }: LeadCreateModalProps) => {
  const createLeadMutation = useCreateLead();
  const { toast } = useToast();

  const handleSubmit = async (formData: LeadFormValues) => {
    try {
      if (!formData.name?.trim()) {
        throw new Error("Nome é obrigatório");
      }

      const created = await createLeadMutation.mutateAsync({
        name: formData.name.trim(),
        email: formData.email?.trim() || undefined,
        phone: formData.phone ? `${formData.phone_country_code || '55'}${formData.phone}` : undefined,
        source: formData.source?.trim() || undefined,
        companyName: formData.companyName,
        website: formData.website,
        industry: formData.industry,
        owner_id: formData.owner_id,
        custom_data: formData.custom_data,
      });

      // Secundários vão num segundo round-trip, depois de o lead existir.
      if (created?.id && needsPhonesRoundTrip(formData.phones ?? [])) {
        const { error } = await persistLeadPhones(created.id, formData.phones ?? []);
        if (error) {
          toast({
            title: "Lead criado, telefones extras não",
            description: `${error} Você pode adicioná-los no perfil do lead.`,
            variant: "destructive",
          });
        }
      }
      onOpenChange(false);
    } catch (error) {
      // Error is handled by the mutation
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-2rem)] sm:w-full max-w-4xl max-h-[90vh] overflow-y-auto p-4 sm:p-6">
        <DialogHeader>
          <DialogTitle>Novo Lead</DialogTitle>
        </DialogHeader>
        
        <LeadForm
          onSubmit={handleSubmit}
          submitLabel="Criar Lead"
          submitting={createLeadMutation.isPending}
        />
      </DialogContent>
    </Dialog>
  );
};